import { Injectable } from '@angular/core'
import { ConverterService, GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { Observable } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'
import { RFP_FORM_SERIALIZER } from '../../converters/eb-rfp-converters'
import { EbRfpFormInterface } from '../../interfaces/eb-rfp.interface'
import { EbRfpFormAdapter } from '../connectors/eb-rfp-form.adapter'

@Injectable()
export class EbRfpFormService {
  constructor(
    protected adapter: EbRfpFormAdapter,
    protected converter: ConverterService,
    protected globalMessageService: GlobalMessageService
  ) {}

  send(form: EbRfpFormInterface): Observable<any> {
    const payload = this.converter.convert(form, RFP_FORM_SERIALIZER)
    return this.adapter.send(payload).pipe(
      catchError(error => {
        this.globalMessageService.add(
          { key: 'rfp.submit.error', params: error },
          GlobalMessageType.MSG_TYPE_ERROR
        )
        return error
      }),
      tap(() => {
        this.globalMessageService.add(
          { key: 'rfp.submit.success' },
          GlobalMessageType.MSG_TYPE_CONFIRMATION
        )
      })
    )
  }
}
